/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:c405f059-f402-45c6-9a3c-a457e2ab265f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_07R7V1iai",
    "aws_user_pools_web_client_id": "4h7lrpldaq4nm7iaupmp97fi7e",
    "oauth": {
        "domain": "aquaappmain.auth.us-east-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 10,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "aqua-api-main-bucket",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
